import { UISubscriptionOverlayController } from '../store/subscription_overlay/UISubscriptionOverlayController.ts';
import { isSubscriptionOverlayVariant } from '../store/subscription_overlay/subscriptionOverlayABTest.ts';
export class UIManagerEvents {
    showSubscriptionOverlayIfVariant() {
        if (!isSubscriptionOverlayVariant()) return false;
        if (this.subscriptionOverlayController == undefined) this.subscriptionOverlayController = this.createSubscriptionOverlayController();
        this.subscriptionOverlayController.show();
        return true;
    }
    // eslint-disable-next-line class-methods-use-this
    createSubscriptionOverlayController() {
        return new UISubscriptionOverlayController();
    }
}
